"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisplayMode = exports.DisplayModeContext = void 0;
var react_1 = require("react");
exports.DisplayModeContext = (0, react_1.createContext)('main');
var useDisplayMode = function () {
    return (0, react_1.useContext)(exports.DisplayModeContext);
};
exports.useDisplayMode = useDisplayMode;
